import React from 'react';
import { useAppDispatch } from '../../utils/storeHooks';
import { toggleModal } from '../../utils/displaySlice';


const BarsIcon = () => {

    const dispatch = useAppDispatch();
    const handleNavClick = () => { dispatch(toggleModal('NavMenu')) };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-9 mr-1.5 hover:cursor-pointer transition-sd hover:text-toto-2 md:size-10 md:mr-2" onClick={handleNavClick}>
            <path fillRule="evenodd" d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z" clipRule="evenodd" />
        </svg>
    )
}

export default BarsIcon